import { render, staticRenderFns } from "./main-header.vue?vue&type=template&id=6037f78d&scoped=true&"
import script from "./main-header.vue?vue&type=script&lang=js&"
export * from "./main-header.vue?vue&type=script&lang=js&"
import style0 from "./main-header.vue?vue&type=style&index=0&id=6037f78d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6037f78d",
  null
  
)

export default component.exports